import qs from "qs";
import { FilterDef, HTTPGenericResponse } from "../../constants/FinanceModels";
import { getFilterValue } from "../../utils/FilterUtils";
import { useApi } from "../Api";
import { ID_FILTER_SEARCH } from "../../pages/cluster/constants/ClustersFilters";
import {
    ID_FILTER_PRINTOUT_TYPE, ID_FILTER_ACRISS, ID_FILTER_SIPP,
    ID_FILTER_EVENT_TYPE, ID_FILTER_VALUE_RATE_FROM, ID_FILTER_VALUE_RATE_TO, ID_FILTER_FROM_KM, ID_FILTER_TO_KM
} from "../../pages/cluster/constants/FixedVoicesFilters";
import { useContext } from "react";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";

export const useClusterFixedVoiceRepository = () => {
    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/cluster-fixed-voice"
    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);

    function getFixedVoices(id: string, offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let printoutType = getFilterValue(ID_FILTER_PRINTOUT_TYPE, filterDefs);
        let eventType: any = getFilterValue(ID_FILTER_EVENT_TYPE, filterDefs);
        let valueRateFrom: any = getFilterValue(ID_FILTER_VALUE_RATE_FROM, filterDefs);
        let valueRateTo: any = getFilterValue(ID_FILTER_VALUE_RATE_TO, filterDefs);
        let acriss = getFilterValue(ID_FILTER_ACRISS, filterDefs);
        let sipp = getFilterValue(ID_FILTER_SIPP, filterDefs);
        let fromKm = getFilterValue(ID_FILTER_FROM_KM, filterDefs);
        let toKm = getFilterValue(ID_FILTER_TO_KM, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            printoutType: printoutType,
            settingsType: eventType,
            commissionFrom: valueRateFrom,
            commissionTo: valueRateTo,
            acriss: acriss,
            sipp: sipp,
            fromKm: fromKm,
            toKm: toKm,
            legalEntities: allLegalEntities
        }

        return GET(`${PATH}/${id}`, { params: params, paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }) });
    }


    function createFixedVoices(idCluster: number, voice: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}/${idCluster}`, voice, {}, true);
    }

    function updateFixedVoices(idCluster: number, idFixedVoice: number, voice: any): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/${idCluster}/${idFixedVoice}`, voice, {}, true);
    }

    function deleteFixedVoices(idFixedVoice: number): Promise<HTTPGenericResponse> {
        return DELETE(`${PATH}/${idFixedVoice}`, undefined, true)
    }

    return { getFixedVoices,  createFixedVoices, updateFixedVoices, deleteFixedVoices };
}